/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // console.log(
      //   'App is being served from cache by a service worker.\n' +
      //   'For more details, visit https://goo.gl/AFskqB'
      // )
      console.log("%cEMONS SELLER", "background: #14008c; color: white;");
    },
    registered() {
      console.log(
        "%cEMONS SELLER: Service worker has been registered.",
        "background: #14008c; color: white;"
      );
      // console.log('Service worker has been registered.')
    },
    cached() {
      // console.log('Content has been cached for offline use.')
      console.log(
        "%cEMONS SELLER: Content has been cached for offline use.",
        "background: #14008c; color: white;"
      );
    },
    updatefound() {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
      // console.log('New content is downloading.')
      console.log(
        "%cEMONS SELLER: New content is downloading",
        "background: #14008c; color: white;"
      );
    },
    updated(registration) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
      // console.log('New content is available; please refresh.')
      console.log(
        "%cEMONS SELLER: New content is available; please refresh.",
        "background: #14008c; color: white;"
      );
      // if (window.confirm("A new version is available, update now?")) {
      const worker = registration.waiting;
      worker.postMessage({ action: "SKIP_WAITING" });
      registration.update();
      // refresh the page or trigger a refresh programatically!
      // }
    },
    offline() {
      // console.log('No internet connection found. App is running in offline mode.')
      console.log(
        "%cEMONS SELLER: No internet connection found. App is running in offline mode.",
        "background: #14008c; color: white;"
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
